import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminWorkGroupEmployeeIDOCToArray, V1AdminWorkGroupIDOCToArray} from "../../../../util/Payload";

class AdminWorkGroupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.AdminWorkGroup-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.AdminWorkGroup-001";

        let foreignKeyName = "";

        let fk = {};
        fk[foreignKeyName] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_work_groups",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminWorkGroupIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
    
    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminWorkGroup = {};

        adminWorkGroup["USID"] = this.getEnterpriseObject().getEnterpriseComponent("AdminWorkGroup").getAttributeValue("USID");
        adminWorkGroup["WorkGroupEmployee"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminWorkGroup-002";
        payload.ShifamedMessage.AdminWorkGroup = adminWorkGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminWorkGroup-002",
                "idoc-response": "v1.AdminWorkGroup-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminWorkGroupEmployeeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminWorkGroup-001";
        payload.ShifamedMessage.AdminWorkGroup = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminWorkGroup-001",
                "idoc-response": "v1.AdminWorkGroup-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminWorkGroupIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };
}

export default AdminWorkGroupEnterpriseComponent;